import { useEffect } from "react";

import { subscribeUploadAnnouncements } from "~/resource/data-source/upload-announcements";

import { showUploadOperation } from "./show-upload-operation";
import { subscribeUploadBatchPresenter } from "./upload-batch-presenter";

export function UploadAnnouncementSubscriber() {
  useEffect(() => {
    const unsubscribeOperations = subscribeUploadAnnouncements(
      ({ operationId, name, retry, cancellationBestEffort }) => {
        showUploadOperation(operationId, name, retry, { cancellationBestEffort });
      },
    );
    const unsubscribeBatch = subscribeUploadBatchPresenter();
    return () => {
      unsubscribeOperations();
      unsubscribeBatch();
    };
  }, []);
  return null;
}
